import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Button, Divider, Typography, Menu, MenuItem } from "@mui/material";

import { SortingButtonIcon } from "../../../../assets/icons/create-feed";
import { PostTypeEnum, postTypesList } from "../../../../enums/post.enum";

const SortFeed = () => {
  const { t } = useTranslation("feed", { keyPrefix: "sortFeed" });
  const { t: tEnum } = useTranslation("feed", { keyPrefix: "enum.postType" });

  const navigate = useNavigate();
  const postSortTypes = postTypesList.map((type) => ({
    label: tEnum(type),
    value: type,
  }));
  const [searchParams] = useSearchParams();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const currentSort = searchParams.get("type") || "ALL";

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSort = (sortType: PostTypeEnum | "ALL") => {
    if (sortType === "ALL") {
      searchParams.delete("type");
      navigate("?" + searchParams.toString());
    } else {
      searchParams.set("type", sortType);
      navigate("?" + searchParams.toString());
    }
    handleClose();
  };

  const getSortLabel = (type: string) => {
    if (type === "ALL") {
      return t("all");
    }
    return tEnum(type as PostTypeEnum);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <Divider sx={{ flex: 1 }} />
      <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <Typography>{t("sortBy")}</Typography>
        <Button
          endIcon={<SortingButtonIcon fill="var(--Dark---600, #707070)" />}
          onClick={handleClick}
          aria-controls={open ? "sort-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          sx={{
            color: "var(--Brand-600, #008B07)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 600,
            backgroundColor: "transparent !important",
            border: "none !important",
          }}
        >
          {getSortLabel(currentSort)}
        </Button>
        <Menu
          id="sort-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "sort-button",
          }}
        >
          <MenuItem onClick={() => handleSort("ALL")}>{t("all")}</MenuItem>
          {postSortTypes.map(
            (type) =>
              type.value != PostTypeEnum.REPOST && (
                <MenuItem key={type.value} onClick={() => handleSort(type.value)}>
                  {type.label}
                </MenuItem>
              )
          )}
        </Menu>
      </Box>
    </Box>
  );
};

export default SortFeed;
